import React from 'react';
import { get } from 'lodash';
import { useMutation } from '@apollo/client';
import { TASK_LIST_CREATE_FROM_TEMPLATE_ASYNC } from 'components/projects/taskList/gql/templates';
import { FormattedMessage } from 'react-intl';
import toast from 'helpers/toast';
import CCEvents, {
  EventNames,
  EventPropertyKeys,
} from '@companycam/companycam-events';
import Steven from 'helpers/steven';
import { graphQLIdDecoder } from 'helpers/graphql-utils';

const useCreateTaskFromTemplate = ({ template, projectNodeId, onSuccess }) => {
  const showErrorToast = (errorMsg) => {
    toast.error(
      errorMsg || (
        <FormattedMessage
          id="Projects.taskList.templates.error.use"
          defaultMessage="There was an error using the template"
          description="Default error message for using template"
        />
      ),
    );
  };

  const handleOnCompleted = (res) => {
    CCEvents.logEvent(EventNames.TASK_LIST_TEMPLATES.USE_TEMPLATE, {
      [EventPropertyKeys.TEMPLATE_ID]: template.id,
      [EventPropertyKeys.TASK_LIST_TYPE]: template.category,
    });
    const taskListDbId = graphQLIdDecoder(res.taskList.id)?.databaseId;
    const templateDbId = graphQLIdDecoder(template.id)?.databaseId;

    Steven.entityCrud({
      action: 'created',
      entity_type: 'checklist',
      entity_id: taskListDbId,
      source: 'template',
      source_id: templateDbId,
    });

    toast.success(
      <FormattedMessage
        id="Projects.taskList.templates.success.use"
        defaultMessage="The checklist was succesfully created"
        description="Success message for using template"
      />,
    );

    onSuccess(get(res, 'taskList.id', null));
  };

  const [createTaskListFromTemplateAsync, { loading }] = useMutation(
    TASK_LIST_CREATE_FROM_TEMPLATE_ASYNC,
    {
      variables: {
        input: {
          id: template.id,
          projectId: projectNodeId,
        },
      },
      onCompleted: ({ taskListCreateFromTemplateAsync: res }) => {
        if (!res.errors.length) {
          handleOnCompleted(res);
        }
      },
      onError: () => {
        showErrorToast();
      },
    },
  );

  return {
    createTaskListFromTemplate: createTaskListFromTemplateAsync,
    loading,
  };
};

export default useCreateTaskFromTemplate;
